export default __webpack_public_path__ + "static/media/partners4.33601ca8.jpg";